import Vue from 'vue'
export const typeCache = {
  quality: [
    { name: '原厂件', type: 0 },
    { name: '品牌件', type: 1 },
    { name: '拆车件', type: 5 },
    { name: '纯4S店件', type: 7 }
  ],
  invoice: [{ name: '不含票', type: 0 }, { name: '含票', type: 1 }],
  payType: [{ name: '支付宝', type: 1 }, { name: '微信', type: 2 }, { name: '好友代付', type: 5 }, { name: '银联支付', type: 9 }],
  status: [
    { name: '待付款', type: 10 },
    { name: '拼团中，待分享', type: 80 },
    { name: '拼团成功，等待商家发货', type: 20 },
    { name: '拼团成功，退款中', type: 90 },
    { name: '商家已发货，待收货', type: 30 },
    { name: '已完成', type: 40 },
    { name: '已取消', type: 50 },
    { name: '已退款', type: 100 }
  ],
  quoteStatus: [
    { name: '待领取', type: 0 },
    { name: '报价中', type: 1 },
    { name: '已完成', type: 10 },
    { name: '已过期', type: 20 }
  ]
}
Vue.filter('type', function (value, type) {
  if (!Array.isArray(typeCache[type])) {
    return ''
  }
  let item = typeCache[type].find((o) => o.type === value)
  return item && item.name
})



// WEBPACK FOOTER //
// ./src/group/filters/type.js